import React from "react";
import { IoHomeSharp } from 'react-icons/io5';
import { IoIosPricetag } from 'react-icons/io'
import { FaCaretDown, FaCaretUp, FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import logsUserService from "../../services/LogsUserActionService";
import { useAuth } from "../../context/AuthContext";

const ModulesComponent = ({
    index,
    topics,
    currentSubmodule,
    currentModule,
    title,
    opened,
    disabled,
    onSwitch,
    onClick
}) => {
    const { token, idUser } = useAuth();

    const toggle = (e) => {
        e.preventDefault();
        logsUserService(idUser, `Clic en el módulo: ${title}`, token);
        onSwitch();
    };

    const handleSubmoduleClick = (e, subIndex) => {
        e.preventDefault();
        const submoduleTitle = topics[subIndex]?.title || "Topic sin título";
        logsUserService(idUser, `Clic en el topic: ${submoduleTitle}`, token);
        onClick(index, subIndex);
    };

    return (
        <div className="z-20">
            <button
                disabled={disabled}
                onClick={toggle}
                className={`text-start text-base font-medium flex items-center gap-2 p-2 m-3 transition-colors duration-300 ease-in-out min-w-52 ${opened === index ? 'bg-light-green' : 'cursor-not-allowed'
                    }`}
            >
                <IoIosPricetag className='size-9 pt-2' />
                <div>{title}</div>
                {opened === index ? <FaCaretDown className='size-3' /> : <FaCaretUp className='size-3' />}
            </button>

            <div
                className={`flex flex-col items-start gap-2 bg-menu-blue pr-6 overflow-hidden transition-all duration-300 ${opened === index ? 'h-auto' : 'h-0'
                    }`}
            >
                <div className='h-6 w-full'></div>

                {topics.map((submodule, i) => {
                    const isActive = i === currentSubmodule && index === currentModule;
                    const isAvailable = submodule?.is_available;

                    return (
                        <button
                            key={i}
                            onClick={isAvailable ? (e) => handleSubmoduleClick(e, i) : undefined}
                            disabled={!isAvailable}
                            className={`text-sm text-start flex items-center justify-start transition-all duration-300 ease-in-out min-w-[13.5rem] ${!isAvailable ? 'text-gray cursor-not-allowed' : 'hover:text-white/90'
                                }`}D
                        >
                            <div
                                className={`h-1 w-7 min-w-7 mr-2 ${isAvailable || isActive ? 'bg-white' : 'bg-transparent'
                                    }`}
                            ></div>
                            <span className={isActive ? 'text-[#0cc5b1]' : ''}>
                                {submodule.title}
                            </span>

                        </button>
                    );
                })}

                <div className='h-6 w-full'></div>
            </div>
        </div>
    );
};

export default ModulesComponent;
